const state = {
  active: false,
  emailaddress: ''
}

export default state